var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row no-gutters flex-fill viewer-panel" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _vm.loading
          ? [_vm._m(0)]
          : [
              _vm.loadingError
                ? [
                    _c(
                      "div",
                      {
                        staticClass: "alert alert-danger",
                        attrs: { role: "alert" },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.errorMsg) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                : _vm.result
                ? [
                    _c(
                      "div",
                      { staticClass: "viewer-results" },
                      [
                        _c(_vm.viewer, {
                          tag: "component",
                          attrs: { data: _vm.viewerData },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading" }, [
      _c("div", {}, [_c("div", { staticClass: "full-size-loader" })]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }